import { useHistory } from 'react-router-dom';
import useRoutes from '../../../useRoutes';
import { resolveStringPlaceholders } from '../../../../utils/json/resolveStringPlaceholders';
import { DatasetControl, LayoutsControlAction } from '../../../../types/types';

// Opens the layouts editor for the control's layoutId.
// objectId is a JSONata expression resolved against the current row.
export const getLayoutsTypeCallback = (
  control: DatasetControl,
  currentRow: any,
  rowsToUse: any[],
  datasetId: string | undefined,
  history: ReturnType<typeof useHistory>,
  routes: ReturnType<typeof useRoutes>
) => {
  return async (): Promise<void> => {
    const action = control.action as LayoutsControlAction;

    let objectId: string | undefined;
    const targetRow =
      currentRow ?? (rowsToUse.length === 1 ? rowsToUse[0] : undefined);
    const resolveData = {
      ...(targetRow ?? {}),
      row: targetRow,
    };

    if (action.objectId && targetRow) {
      const resolved = await resolveStringPlaceholders(
        action.objectId,
        resolveData
      );
      objectId =
        resolved === undefined || resolved === null
          ? undefined
          : String(resolved);
    }

    const url = routes.layoutEditor(datasetId ?? '', action.layoutId, objectId);

    history.push(url);
  };
};
